import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { AlertService } from 'src/app/shared/services/alert.service';
import { SafeHtmlPipe } from '../../../pipes/safeHtml.pipe';

@Component({
  selector: 'app-alert-message-detail',
  templateUrl: './alert-message-detail.component.html',
  styleUrls: ['./alert-message-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SafeHtmlPipe],
})
export class AlertMessageDetailComponent implements OnInit {
  private alertService = inject(AlertService);

  @Input() public messageContent: string;
  public ngOnInit(): void {
    this.messageContent = this.messageContent || '';
  }
}
